import { render, staticRenderFns } from "./visualizarPagamento.vue?vue&type=template&id=3b6eb988&scoped=true&"
import script from "./visualizarPagamento.vue?vue&type=script&lang=js&"
export * from "./visualizarPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6eb988",
  null
  
)

export default component.exports